import styled from 'styled-components';

export const CaptionContainer = styled.div`
	display: table-caption;
	margin-bottom: 0.5em;
	margin-right: 4em;
	padding: 0 0.5em;
	text-align: left;
`;
